import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const joeSandbox = defineConnector({
  identifier: "joeSandbox",
  name: "Joe Sandbox",
  tagLine: "Automated malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://((www|jbxcloud)\\.joesandbox\\.com|jbxcloud\\.joesecurity\\.org)/api/.*",
  auth: customAuth("joeSandbox"),
  usageHint: () =>
    "POST form-encoded or multipart requests. The proxy writes the API key into the apikey field of the body. Submitting a sample to /api/v2/submission/new also requires accept-tac=1.",
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Joe Sandbox](https://www.joesandbox.com/), open the user icon, choose **User Settings > API Key**, and copy the API key shown there.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Joe Sandbox API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://www.joesandbox.com/api/v2/server/online",
      method: "POST",
    }),
  },
});
